import { mutator } from 'satcheljs';
import { onSmimeEncryptChanged } from '../actions/internalActions';
import store from '../store/store';

/**
 * Mutator that sets the property smimeEncrypt
 */
export default mutator(onSmimeEncryptChanged, actionMessage => {
    store().isSmimeEncrypt = actionMessage.selectedOption;
});
